// extracted by mini-css-extract-plugin
module.exports = {"previousOffer":"_1zMge","expiredOffer":"_2qAfD","chatWrapper":"_9Uemz"};